/* eslint-disable import/prefer-default-export */
export const USER_TYPES = {
  STUDENT: 'student',
  COUNSELOR: 'counselor',
  GUARDIAN: 'guardian',
  OTHER: 'other',
  K12_ADMIN: 'k12_admin',
  MEMBER: 'member',
  ORGANIZATION_GUEST: 'organization_guest',
  RECOMMENDER: 'recommender',
};

// source is from sl-py
// sl_users/fixtures/groups.json
export const USER_TYPE_IDS = {
  STUDENT: 1,
  K12_ADMIN: 2,
  GUARDIAN: 4,
  LOR_WRITER: 6,
  SUPERVISOR: 7,
  MEMBER: 9,
  DATA_ADMIN: 10,
  RECOMMENDER: 11,
  COMMUNITY_PARTNER_ADMIN: 12,
  ORGANIZATION_GUEST: 14,
  MIGHTY_PRO: 15,
};
